import { generatePdf } from "../../utilities/PDFMakeUtil";
import pdfImage from "../../components/PDF/pdfImage";

export const pdfRPT245 = (dataReport, dataRPTScore, setLoading, setDialogPDF) => {
    setLoading(true);
    let data_1 = dataReport;
    let data_2 = dataRPTScore;
    
    let ol_arr = [];
    for (let i = 0; i < data_1.length; i++) {
        ol_arr.push([
            { style: "fontStyle_center", text: data_1[i].criteriaNo == 999 ? "" : data_1[i].criteriaNo },
            { style: "fontStyle_center", text: data_1[i].criteriaDesc },
            { style: "fontStyle_center", text: data_1[i].criteriaWeight },
            { style: "fontStyle_center", text: data_1[i].criteriaScore },
            { style: "fontStyle_center", text: data_1[i].criteriaRemark },
        ]);
    }
    const handlerCheck = (key) => {
        return key === "Y" ? pdfImage.checkBox : pdfImage.unchecked;
    };

    // page 1
    const container_1 = {
        table: {
            widths: ["*", "*"],
            style: "fontStyle",

            body: [
                [
                    {
                        border: [1, 1, 1, 0],
                        layout: "noBorders",
                        table: {
                            widths: ["*", "*"],
                            body: [
                                [
                                    { text: "", margin: [0, 5, 0, 0] },
                                    { text: "", margin: [0, 5, 0, 0] },
                                ],
                                [
                                    { image: pdfImage.logoPWA_1, width: 100, height: 30 },
                                    { style: "header", text: "การประปานครหลวง" },
                                ],
                            ],
                        },
                    },
                    {
                        border: [1, 1, 1, 0],
                        layout: "noBorders",
                        table: {
                            widths: [20, "*", 20, "*", 20, "*"],
                            body: [
                                [
                                    { text: "", margin: [0, 5, 0, 0] },
                                    { text: "", margin: [0, 5, 0, 0] },
                                    { text: "", margin: [0, 5, 0, 0] },
                                    { text: "", margin: [0, 5, 0, 0] },
                                    { text: "", margin: [0, 5, 0, 0] },
                                    { text: "", margin: [0, 5, 0, 0] },
                                ],
                                [
                                    { image: pdfImage.unchecked, width: 15, height: 15 },
                                    { style: { alignment: "left", fontSize: 16, bold: true }, text: "ฝกจ ...." },
                                    { image: handlerCheck(data_1[0].branchFlag), width: 15, height: 15 },
                                    { style: { alignment: "left", fontSize: 16, bold: true }, text: data_1[0].branchAbbName + " ......" },
                                    { image: pdfImage.unchecked, width: 15, height: 15 },
                                    { style: { alignment: "left", fontSize: 16, bold: true }, text: "..........." },
                                ],
                            ],
                        },
                    },
                ],
                [{ border: [1, 1, 1, 0], colSpan: 2, style: "fontStyle_center", text: "ใบประเมินผลงานของผู้รับจ้าง\nสำหรับงานก่อสร้างวางท่อจ่ายน้ำและซ่อมท่อ ทุกสัญญา" }, {}],
            ],
        },
    };

    const container_2 = {
        table: {
            widths: ["*"],
            style: "fontStyle",
            body: [
                [
                    {
                        border: [1, 1, 1, 0],

                        layout: "noBorders",
                        table: {
                            widths: ["35%", "3%", "16%", "10%", "3%", "10%", "3%", "15%"],
                            style: "fontStyle",
                            body: [
                                [
                                    { margin: [0, 5, 0, 0], style: "fontStyle", text: "ระยะเวลาการประเมิน ............................" },
                                    { image: handlerCheck(data_1[0].assessmentFlag1), width: 15, height: 15 },
                                    { margin: [0, 5, 0, 0], style: "fontStyle", text: "ระหว่างก่อสร้างจาก" },
                                    { margin: [0, 5, 0, 0], style: "signature", text: data_1[0].assessmentBeginDate },
                                    { margin: [0, 5, 0, 0], style: "fontStyle", text: "ถึง" },
                                    { margin: [0, 5, 0, 0], style: "signature", text: data_1[0].assessmentEndDate },
                                    { image: handlerCheck(data_1[0].assessmentFlag2), width: 15, height: 15 },
                                    { margin: [0, 5, 0, 0], style: "fontStyle", text: "เมื่อสิ้นสุดสัญญา" },
                                ],
                            ],
                        },
                    },
                ],
                [
                    {
                        border: [1, 0, 1, 0],
                        layout: "noBorders",
                        table: {
                            widths: ["*", "*", "*", "*"],
                            style: "fontStyle",
                            body: [
                                [
                                    { style: "fontStyle", text: "สัญญา" },
                                    { style: "signature", text: data_1[0].contractNo },
                                    { style: "fontStyle", text: "วันที่ลงนามในสัญญา" },
                                    { style: "signature", text: data_1[0].contractSignDate },
                                ],
                            ],
                        },
                    },
                ],
                [
                    {
                        border: [1, 0, 1, 0],

                        layout: "noBorders",
                        table: {
                            widths: [50, "*", 60, 10, 50, 10, 50, 10, 50],
                            style: "fontStyle",
                            body: [
                                [
                                    { style: "fontStyle", text: "ผู้รับจ้าง" },
                                    { style: "signature", text: " " + data_1[0].contractorName + " " },
                                    { style: "fontStyle", text: "ลักษณะงาน" },
                                    { image: handlerCheck(data_1[0].pipeType1), width: 15, height: 15 },
                                    { style: "fontStyle", text: "ท่อประธาน" },
                                    { image: handlerCheck(data_1[0].pipeType2), width: 15, height: 15 },
                                    { style: "fontStyle", text: "ท่อจ่ายน้ำ" },
                                    { image: handlerCheck(data_1[0].pipeType3), width: 15, height: 15 },
                                    { style: "fontStyle", text: "ท่อบริการ" },
                                ],
                            ],
                        },
                    },
                ],
                [
                    {
                        border: [1, 0, 1, 0],

                        layout: "noBorders",
                        table: {
                            widths: [60, "*", 80, "*", 60, "*", 30],
                            style: "fontStyle",
                            body: [
                                [
                                    { style: "fontStyle", text: "วันที่เริ่มงาน" },
                                    { style: "signature", text: " " + data_1[0].contractBeginDate + "" },
                                    { style: "fontStyle", text: "วันที่สิ้นสุดสัญญา" },
                                    { style: "signature", text: " " + data_1[0].contractEndDate + " " },
                                    { style: "fontStyle", text: "วงเงินค่างาน" },
                                    { style: "signature", text: " " + data_1[0].contractAmount + " " },
                                    { style: "fontStyle", text: "บาท" },
                                ],
                            ],
                        },
                    },
                ],
                [
                    {
                        border: [1, 0, 1, 0],

                        layout: "noBorders",
                        table: {
                            widths: ["*", "*"],
                            style: "fontStyle",
                            body: [
                                [
                                    { style: "fontStyle_right", text: "วันที่งานแล้วเสร็จจริง" },
                                    { style: "signature", text: " " + data_1[0].actualEndDate + " " },
                                ],
                            ],
                        },
                    },
                ],
            ],
        },
    };

    const container_3 = {
        table: {
            widths: ["5%", "*", "6%", "8.5%", "*"],
            headerRows: 2,
            style: "fontStyle",
            body: [
                [
                    { text: "ข้อ", style: "tableHeader", alignment: "center" },
                    { text: "หัวข้อพิจารณา", style: "tableHeader", alignment: "center" },
                    { text: "น้ำหนัก", style: "tableHeader", alignment: "center" },
                    { text: "คะแนนที่ได้", style: "tableHeader", alignment: "center" },
                    { text: "สาเหตุ", style: "tableHeader", alignment: "center" },
                ],
                ...ol_arr,
            ],
        },
    };

    const sum_criteriaWeight = () => {
        let sum = 0;
        for (const iterator of data_1) {
            sum += iterator.criteriaWeight;
        }
        return sum;
    };

    const footer_container_3 = {
        table: {
            widths: ["5%", "*", "6%", "8.5%", "*"],
            style: "fontStyle",
            body: [
                [
                    { border: [1, 0, 1, 1], colSpan: 2, text: "" },
                    {},
                    { border: [1, 0, 1, 1], text: sum_criteriaWeight(), style: "fontStyle", alignment: "center" },
                    { border: [1, 0, 1, 1], text: "" },
                    { border: [1, 0, 1, 0], text: "ถูกตัดคะแนนสะสม: " + data_1[0].deductScore, style: "fontStyle", alignment: "center" },
                ],
            ],
        },
    };

    const container_4 = {
        table: {
            widths: ["*"],
            style: "fontStyle",
            body: [
                [
                    {
                        border: [1, 0, 1, 0],

                        layout: "noBorders",
                        table: {
                            widths: ["11%", "4%", "20%", "7%", "4%", "20%", "7%", "20%", "*"],
                            style: "fontStyle",
                            body: [
                                [
                                    { style: "signature_wavy", text: "ผลงานที่ทำได้" },
                                    { image: pdfImage.unchecked, width: 15, height: 15 },
                                    { style: "fontStyle", text: "เร็วกว่าแผนสัญญา" },
                                    { style: "signature", text: "     " },
                                    { image: pdfImage.unchecked, width: 15, height: 15 },
                                    { style: "fontStyle", text: "ทันตามแผนสัญญา" },
                                    { image: pdfImage.unchecked, width: 15, height: 15 },
                                    { style: "fontStyle", text: "ช้ากว่าแผนสัญญา" },
                                    { style: "signature", text: "     " },
                                ],
                            ],
                        },
                    },
                ],
                [
                    {
                        border: [1, 0, 1, 0],

                        layout: "noBorders",
                        table: {
                            widths: ["14%", "4%", "20%", "4%", "20%", "7%", "20%", "*"],
                            style: "fontStyle",
                            body: [
                                [
                                    { style: "signature_wavy", text: "ผลการประเมิน" },
                                    { image: pdfImage.unchecked, width: 15, height: 15 },
                                    { style: "fontStyle", text: "ผ่านการประเมิน" },
                                    { image: pdfImage.unchecked, width: 15, height: 15 },
                                    { style: "fontStyle", text: "ไม่ผ่านการประเมิน" },
                                    { style: "fontStyle", text: "ค่าปรับ" },
                                    { style: "signature", text: data_1[0].fineAmount },
                                    { style: "fontStyle", text: "บาท" },
                                ],
                            ],
                        },
                    },
                ],
                [
                    {
                        border: [1, 0, 1, 0],

                        layout: "noBorders",
                        table: {
                            widths: ["50%", "50%"],
                            style: "fontStyle",
                            body: [
                                [
                                    { style: "signature_wavy", text: "ข้อสรุปและวิจารณ์" },
                                    { margin: [85, 0, 0, 0], style: "fontStyle", text: "เรียน ผอ.ฝ่ายฯ/ผจ.สส........." },
                                ],
                            ],
                        },
                    },
                ],
                [
                    {
                        border: [1, 0, 1, 0],

                        layout: "noBorders",
                        table: {
                            widths: ["50%", "50%"],
                            style: "fontStyle",
                            body: [
                                [
                                    { margin: [20, 0, 0, 0], style: "signature", text: data_1[0].assessmentDetail },
                                    {
                                        alignment: "center",
                                        border: [1, 0, 1, 0],
                                        layout: "noBorders",
                                        table: {
                                            widths: ["100%"],
                                            style: "fontStyle",
                                            body: [
                                                [{ margin: [20, 0, 0, 0], style: "fontStyle", text: "เพื่อโปรดพิจารณาให้ความเห็นชอบ" }],
                                                [{ style: "fontStyle", text: "ลงชื่อ ..........................................................." }],
                                                [{ margin: [20, 0, 0, 0], style: "fontStyle", text: "(...........................................................)" }],
                                                [{ style: "fontStyle", text: "ตำแหน่ง (ผอ.กองฯ)" }],
                                                [{ style: "fontStyle", text: "วันที่ ..........................................................." }],
                                            ],
                                        },
                                    },
                                ],
                            ],
                        },
                    },
                ],
                [
                    {
                        border: [1, 0, 1, 0],

                        layout: "noBorders",
                        table: {
                            widths: ["50%", "50%"],
                            style: "fontStyle",
                            body: [
                                [
                                    {
                                        border: [1, 0, 1, 0],
                                        layout: "noBorders",
                                        alignment: "center",
                                        table: {
                                            widths: ["100%"],
                                            style: "fontStyle",
                                            body: [
                                                [{ style: "fontStyle", text: "เรียน (ผอ.กองฯ)" }],
                                                [{ margin: [20, 0, 0, 0], style: "fontStyle", text: "เพื่อโปรดพิจารณา" }],
                                                [{ style: "fontStyle", text: "ลงชื่อ ..........................................................." }],
                                                [{ margin: [20, 0, 0, 0], style: "fontStyle", text: "(...........................................................)" }],
                                                [{ margin: [40, 0, 0, 0], style: "fontStyle", text: "วิศวกรผู้ควบคุมงาน" }],
                                                [{ style: "fontStyle", text: "วันที่ประเมิน ..........................................................." }],
                                            ],
                                        },
                                    },
                                    {
                                        alignment: "center",
                                        border: [1, 0, 1, 0],
                                        layout: "noBorders",
                                        table: {
                                            widths: ["100%"],
                                            style: "fontStyle",
                                            body: [
                                                [{ margin: [20, 0, 0, 0], style: "fontStyle", text: "เห็นชอบผลการประเมิน" }],
                                                [{ style: "fontStyle", text: "ลงชื่อ ..........................................................." }],
                                                [{ margin: [20, 0, 0, 0], style: "fontStyle", text: "(...........................................................)" }],
                                                [{ style: "fontStyle", text: "ตำแหน่ง (ผอ.ฝ่ายฯ/ผจ.สส)" }],
                                                [{ style: "fontStyle", text: "วันที่ ..........................................................." }],
                                            ],
                                        },
                                    },
                                ],
                            ],
                        },
                    },
                ],
            ],
        },
    };

    const container_5 = {
        table: {
            widths: ["50%", "50%"],
            style: "fontStyle",
            body: [
                [
                    { border: [1, 1, 1, 1], margin: [0, 5, 0, 0], style: "fontStyle", text: "ที่ ............................../.............................. วันที่ ............................................................" },
                    { border: [1, 1, 1, 0], text: "" },
                ],
            ],
        },
    };

    const container_6 = {
        table: {
            widths: ["50%", "50%"],
            style: "fontStyle",

            body: [
                [
                    {
                        border: [1, 0, 1, 1],
                        layout: "noBorders",
                        table: {
                            widths: ["100%"],
                            style: "fontStyle",
                            body: [
                                [
                                    {
                                        border: [1, 0, 1, 1],
                                        layout: "noBorders",
                                        alignment: "center",
                                        table: {
                                            widths: ["100%"],
                                            style: "fontStyle",
                                            body: [
                                                [
                                                    {
                                                        layout: "noBorders",
                                                        table: {
                                                            widths: ["10%", "7%", "10%", "7%", "10%"],
                                                            style: "fontStyle",
                                                            body: [
                                                                [
                                                                    { style: "fontStyle", text: "เรียน" },
                                                                    { image: pdfImage.unchecked, width: 15, height: 15 },
                                                                    { style: "fontStyle", text: "ผอ.ศปส" },
                                                                    { image: pdfImage.unchecked, width: 15, height: 15 },
                                                                    { style: "fontStyle", text: "ผอ.กธบ." },
                                                                ],
                                                            ],
                                                        },
                                                    },
                                                ],
                                                [{ style: "fontStyle", text: "เพื่อทราบและดำเนินการต่อไป" }],
                                                [{ style: "fontStyle", text: "ลงชื่อ ..........................................................." }],
                                                [{ margin: [20, 0, 0, 0], style: "fontStyle", text: "(...........................................................)" }],
                                                [{ style: "fontStyle", text: "ตำแหน่ง (ผอ.ฝ่ายฯ/ผจ.สส...)" }],
                                                [{ style: "fontStyle", text: "วันที่ ..........................................................." }],
                                            ],
                                        },
                                    },
                                ],
                            ],
                        },
                    },
                    {
                        border: [1, 0, 1, 1],
                        layout: "noBorders",
                        table: {
                            widths: ["100%"],
                            style: "fontStyle",
                            body: [
                                [
                                    {
                                        alignment: "center",
                                        layout: "noBorders",
                                        table: {
                                            widths: ["100%"],
                                            style: "fontStyle",
                                            body: [
                                                [{ style: "fontStyle", text: "เรียน ..........................................................." }],
                                                [{ style: "fontStyle", text: "เพื่อดำเนินการต่อไป" }],
                                                [{ style: "fontStyle", text: "ลงชื่อ ..........................................................." }],
                                                [{ margin: [20, 0, 0, 0], style: "fontStyle", text: "(...........................................................)" }],
                                                [{ style: "fontStyle", text: "ตำแหน่ง ผอ.ศปส" }],
                                                [{ style: "fontStyle", text: "วันที่ ..........................................................." }],
                                            ],
                                        },
                                    },
                                ],
                            ],
                        },
                    },
                ],
            ],
        },
    };

    const container_7 = {
        table: {
            widths: ["50%", "50%"],
            style: "fontStyle",
            body: [
                [
                    {
                        border: [1, 0, 1, 1],
                        layout: "noBorders",
                        table: {
                            widths: ["100%"],
                            style: "fontStyle",
                            body: [
                                [
                                    {
                                        border: [1, 0, 1, 1],
                                        layout: "noBorders",
                                        table: {
                                            widths: ["15%", "83%"],
                                            style: "fontStyle",
                                            body: [
                                                [
                                                    { style: "signature_wavy", bold: true, text: "หมายเหตุ" },
                                                    { style: "fontStyle", text: "-ผลงานที่ทำได้ ส่วนที่ช้าเร็วกว่าแผน/สัญญาหากเป็นการประเมินผลระหว่างก่อสร้าง ให้ระบุเป็นร้อยละหากเป็นการประเมินผลเมื่อสิ้นสุดงานในสัญญา ให้ระบุเป็นจำนวนวัน" },
                                                ],
                                            ],
                                        },
                                    },
                                ],
                            ],
                        },
                    },
                    {
                        border: [1, 0, 1, 1],
                        layout: "noBorders",
                        table: {
                            widths: ["100%"],
                            style: "fontStyle",
                            body: [
                                [
                                    {
                                        alignment: "center",
                                        layout: "noBorders",
                                        table: {
                                            widths: ["100%"],
                                            style: "fontStyle",
                                            body: [
                                                [
                                                    {
                                                        layout: "noBorders",
                                                        table: {
                                                            widths: ["32%", "7%", "22%", "7%", "29%"],
                                                            style: "fontStyle",
                                                            body: [
                                                                [
                                                                    { style: "fontStyle", text: "ผลการตรวจสอบการประเมิน" },
                                                                    { image: pdfImage.unchecked, width: 15, height: 15 },
                                                                    { style: "fontStyle", text: "ไม่มีการแก้ไข" },
                                                                    { image: pdfImage.unchecked, width: 15, height: 15 },
                                                                    { style: "fontStyle", text: "มีการแก้ไขและแก้ไขแล้ว" },
                                                                ],
                                                            ],
                                                        },
                                                    },
                                                ],
                                                [{ style: "fontStyle", text: "..........................................................." }],
                                                [{ margin: [20, 0, 0, 0], style: "fontStyle", text: "(...........................................................)" }],
                                                [{ style: "fontStyle", text: "ตำแหน่ง ..........................................................." }],
                                                [{ style: "fontStyle", text: "วันที่ตรวจสอบ ..........................................................." }],
                                            ],
                                        },
                                    },
                                ],
                            ],
                        },
                    },
                ],
            ],
        },
    };

    // page 2

    const container_8 = {
        layout: "noBorders",
        table: {
            widths: ["2%", "90%"],
            style: "fontStyle",
            body: [
                [{ pageBreak: "after", text: "" }, { text: "" }],
                [{ style: "fontStyle_center", bold: true, colSpan: 2, text: "คำชี้แจงในการประเมินผลงานก่อสร้างของผู้รับจ้าง (แบบประเมิณที่ 1)" }, {}],
                [{ style: "fontStyle_center", bold: true, colSpan: 2, text: "สำหรับงานก่อสร้างวางท่อจ่ายน้ำกับท่อบริการที่มีค่างาน" }, {}],
                [{ style: "fontStyle", bold: true, colSpan: 2, text: "ผู้ประเมินโปรดอ่านคำชี้แจงนี้โดยละเอียดและปฏิบัติตามขั้นตอนและหลักเกณฑ์ในการพิจารณาผลงานก่อสร้างของผู้รับจ้าง" }, {}],
                [{ style: "fontStyle", bold: true, colSpan: 2, text: "ประกอบการให้คะแนนด้วย" }, {}],
                [
                    { style: "fontStyle", text: "1." },
                    { style: "fontStyle", text: "ผู้ประเมินผลต้องเป็นผู้ควบคุมงาน(นายช่างโครงการ) และจะต้องวิจารณ์สรุปผลการปฏิบัติงานของผู้รับจ้างเสนอผู้บังคับบัญชาตามระดับชั้นจนถึงผู้อำนวยการฝ่าย/ผู้จัดการสำนักงานประปาสาขา ให้ความเห็นชอบ" },
                ],
                [
                    { style: "fontStyle", text: "2." },
                    {
                        style: "fontStyle",
                        text: "ในกรณีประเมินผลระหว่างก่อสร้างสำหรับสัญญาที่มีค่างานมากกว่า 6 แสนบาทถึง 10 ล้านบาท ระยะเวลาการประเมินผลให้นับตั้งแต่วันที่แจ้งให้เริ่มงานหรือถัดจากวันที่มีการประเมินผลในคราวก่อนไปอีกเป็นเวลา 6 เดือน และสำหรับสัญญาที่มีค่างานน้อยกว่า6 แสนบาทให้ดำเนินการประเมินครั้งเดียวเมื่องานแล้วเสร็จทั้งสัญญา",
                    },
                ],
                [
                    { style: "fontStyle", text: "3." },
                    {
                        style: "fontStyle",
                        text: "ในกรณีประเมินผลเมื่อสิ้นสุดงานในสัญญา ระยะเวลาการประเมินผลให้นับตั้งแต่วันที่แจ้งให้เริ่มงานในสัญญาจ้างจนถึงวันที่คณะกรรมการตรวจการจ้างตรวจรับงานงวดสุดท้ายแล้ว หรือตามที่กำหนดในหลักเกณฑ์ฯ",
                    },
                ],
                [
                    { style: "fontStyle", text: "4." },
                    {
                        style: "fontStyle",
                        text: "การประเมินผลงานก่อสร้างจะต้องนำการคัดคะแนนผู้รับจ้าง ตามเกณฑ์การตัดคะแนนในกรณีต่างๆ มาประกอบการพิจารณาด้วย",
                    },
                ],
                [
                    { style: "fontStyle", text: "5." },
                    {
                        style: "fontStyle",
                        text: "คะแนนทั่วไปที่กำหนดให้ ดีมาก 5 คะแนน, ดี 4 คะแนน, พอใช้ 3 คะแนน, ปรับปรุง 2 คะแนน, ต้องแก้ไข 1 คะแนน",
                    },
                ],
                [
                    { style: "fontStyle", text: "6." },
                    {
                        style: "fontStyle",
                        text: `การให้คะแนน ให้ลงคะแนน 1-5 ในช่องที่ต้องการเพียงช่องเดียวต่อหนึ่งหัวข้อ โดยใช้ "เกณฑ์ในการพิจารณาประเมินผลงานก่อสร้างของผู้รับจ้าง ทุกหัวข้อ"`,
                    },
                ],
                [
                    { style: "fontStyle", text: "7." },
                    {
                        style: "fontStyle",
                        text: "หัวข้อหรือรายการใดที่ไม่เกี่ยวข้องกับงานหรือไม่มีขั้นตอนของงานนั้น ไม่ต้องให้คะแนนใดๆ",
                    },
                ],
                [
                    { style: "fontStyle", text: "8." },
                    {
                        style: "fontStyle",
                        text: "การคิดคะแนนตามขั้นตอนสุดท้าย เพื่อพิจารณาตามเกณฑ์ที่จะผ่านการประเมินผลนั้น หากมีจุดทศนิยมให้ปัดเป็นจำนวนเต็มก่อนการพิจารณา",
                    },
                ],
                [
                    { style: "fontStyle", text: "9." },
                    {
                        style: "fontStyle",
                        text: "เกณฑ์ที่จะผ่านการประเมินผลนั้น คือเกณฑ์คะแนน 60",
                    },
                ],
            ],
        },
    };

    // score

    let mapping_score = [];
    let index = 0;
    let TotalItemWeight = 0;
    let TotalItemPoint = 0;

    const addRowTotalPoint = (_totalPaint) => {
        return [
            { border: [1, 0, 0, 0], text: "", style: "fontStyle", alignment: "center" },
            { text: "รวม", style: "fontStyle" },
            { text: _totalPaint, style: "fontStyle", alignment: "center" },
            { text: "", style: "fontStyle", alignment: "center" },
            { colSpan: 5, rowSpan: 2, text: "" },
            {},
            {},
            {},
            {},
        ];
    };
    const addRowTotalWeight = (_totalWight) => {
        return [
            { border: [1, 0, 0, 1], text: "", style: "fontStyle", alignment: "center" },
            {
                colSpan: 2,
                layout: "noBorders",
                table: {
                    style: "fontStyle",
                    widths: ["20%", "50%"],
                    body: [
                        [
                            { style: "fontStyle", text: "คะแนนที่ได้" },
                            { style: "signature_wavy", text: "รวม (น้ำหนัก X คะแนน) = " },
                        ],
                        [{ text: "" }, { margin: [20, 0, 0, 0], style: "fontStyle", text: "5" }],
                    ],
                },
                style: "fontStyle",
            },
            {},
            { text: _totalWight, style: "fontStyle", alignment: "center" },
            {},
            {},
            {},
            {},
            {},
        ];
    };

    const addRowScore = (iterator) => {
        return [
            { border: [1, 0, 0, 0], text: iterator.itemGroupId, style: "fontStyle", alignment: "center" },
            { text: iterator.itemDesc, style: "fontStyle" },
            { text: iterator.itemWeight === null ? "" : iterator.itemWeight, style: "fontStyle", alignment: "center" },
            { text: iterator.itemPoint === null ? "" : iterator.itemPoint, style: "fontStyle", alignment: "center" },
            { text: iterator.itemScore5 === "Y" ? "X" : "", style: "fontStyle", alignment: "center" },
            { text: iterator.itemScore4 === "Y" ? "X" : "", style: "fontStyle", alignment: "center" },
            { text: iterator.itemScore3 === "Y" ? "X" : "", style: "fontStyle", alignment: "center" },
            { text: iterator.itemScore2 === "Y" ? "X" : "", style: "fontStyle", alignment: "center" },
            { text: iterator.itemScore1 === "Y" ? "X" : "", style: "fontStyle", alignment: "center" },
        ];
    };
    for (const iterator of data_2) {
        if (iterator.itemWeight !== null) {
            TotalItemWeight += iterator.itemWeight;
            TotalItemPoint += iterator.itemPoint;
        }

        if (iterator.itemGroupId !== "" && index > 0) {
            mapping_score.push(addRowTotalPoint(TotalItemWeight));
            mapping_score.push(addRowTotalWeight(TotalItemPoint));
            TotalItemWeight = 0;
            TotalItemPoint = 0;
        }
        mapping_score.push(addRowScore(iterator));
        index++;
    }
    mapping_score.push(addRowTotalPoint(TotalItemWeight));
    mapping_score.push(addRowTotalWeight(TotalItemPoint));

    const container_9 = {
        table: {
            headerRows: 1,
            dontBreakRows: true,
            widths: ["7%", "40%", "*", "*", "*", "*", "*", "*", "*"],
            style: "fontStyle",
            body: [
                [
                    { border: [1, 1, 1, 1], text: "ลำดับที่", style: "tableHeader", alignment: "center" },
                    { border: [1, 1, 1, 0], text: "รายการที่ประเมินผล", style: "tableHeader", alignment: "center" },
                    { border: [1, 1, 1, 0], text: "น้ำหนัก", style: "tableHeader", alignment: "center" },
                    { border: [1, 1, 1, 0], text: "น้ำหนัก x คะแนน", style: "tableHeader", alignment: "center" },
                    { border: [1, 1, 1, 0], text: "ดีมาก\n(5)", style: "tableHeader", alignment: "center" },
                    { border: [1, 1, 1, 0], text: "ดี\n(4)", style: "tableHeader", alignment: "center" },
                    { border: [1, 1, 1, 0], text: "พอใช้ (3)", style: "tableHeader", alignment: "center" },
                    { border: [1, 1, 1, 0], text: "ปรับปรุง (2)", style: "tableHeader", alignment: "center" },
                    { border: [1, 1, 1, 0], text: "ต้องแก้ไข (1)", style: "tableHeader", alignment: "center" },
                ],
                ...mapping_score,
            ],
        },
    };

    var sheet = {
        content: [container_1, container_2, container_3, footer_container_3, container_4, container_5, container_6, container_7, container_8, container_9],
        styles: {
            header: {
                alignment: "left",
                fontSize: 14,
                bold: true,
                margin: [0, 0, 0, 10],
            },
            fontStyle: {
                fontSize: 14,
            },
            fontStyle_center: {
                alignment: "center",
                fontSize: 14,
            },
            fontStyle_left: {
                alignment: "left",
                fontSize: 14,
            },
            fontStyle_right: {
                alignment: "right",
                fontSize: 14,
            },
            tableExample: {
                alignment: "right",
                margin: [0, 5, 0, 15],
            },
            tableHeader: {
                bold: true,
                fontSize: 14,
                color: "black",
            },
            signature: {
                fontSize: 14,
                decoration: "underline",
                decorationStyle: "dotted",
                decorationColor: "black",
            },
            signature_dashed: {
                fontSize: 14,
                decoration: "underline",
                decorationStyle: "dashed",
                decorationColor: "black",
            },
            signature_wavy: {
                fontSize: 14,
                decoration: "underline",
                decorationStyle: "wavyF",
                decorationColor: "black",
            },
        },
        pageOrientation: "portrait",
        pageSize: "A4",
        pageMargins: [30, 20, 30, 20],
        defaultStyle: {
            font: "THSarabunNew",
            alignment: "justify",
        },
    };

    generatePdf(true, sheet, (dataUrl) => {
        setDialogPDF({ open: false, pdfURL: dataUrl });
        setLoading(false);
    });
};
